<template>
  <div style="background: #f7f9fc;height: 900px;">
    <header class="header-2">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="header-top">
              <div class="logo-area " style="display: None">
                <a href="javascript:;" class=""
                  ><img
                    class="examLogo"
                    src="/jnrd/examEntrance/img/logo.png"
                    alt=""
                    style="display: block;"
                /></a>
              </div>
              <div class="" style="color: white;margin:0 123px">
                <h3 class="examTitle">职业技能等级认定考试</h3>
              </div>
              <div class="top-nav" style="display: flex;font-size: 15px;">
                <div class="dropdown header-top-notification">
                  <a href="/" class="" style="color: white">退出</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="alice-bg padding-top-70 padding-bottom-70"></div>
    <div class="alice-bg section-padding-bottom">
      <div class="container">
        <div class="row no-gutters">
          <div class="col">
            <v-spin
              :spinning="loadingFlag"
              tip="正在读取数据."
              size="large"
              class="filtered-employer-wrapper"
              style="min-height: 200px;"
            >
              <div class="employer-view-controller-wrapper">
                <div class="employer-view-controller">
                  <div class="employer-view-filter">
                    <div class="dropdown bootstrap-select"></div>
                  </div>
                </div>
                <div style="display: none" class="showing-number">
                  <span id="examCount">考试：1场</span>
                </div>
                <div class="showing-number">
                  <span id="servertime"
                    >北京时间：{{ currentTime }} {{ currentDay }}</span
                  >
                </div>
              </div>

              <div class="employer-filter-result">
                <div
                  class="employer"
                  v-for="(item, index) in examlist"
                  :key="index"
                >
                  <div class="thumb">
                    <a
                      ><img
                        src="../../../static/img/kaoshi.png"
                        class="img-fluid"
                        alt=""
                    /></a>
                  </div>
                  <div class="body">
                    <div class="content" style="width: 521px!important;">
                      <h4>
                        <a href="javascript:;">{{ item.examTitle }}</a>
                      </h4>
                      <div class="info">
                        <span class="location">
                          <a href="#">
                            <i data-feather="map-pin"></i>
                            考试时间：{{ item.beginTime }}
                          </a>
                        </span>
                        <span class="location">
                          <a href="#">
                            <i data-feather="map-pin"> </i>距离开考：
                            <span style="color:red">{{ list[index] }}</span>
                          </a>
                        </span>
                      </div>
                    </div>
                    <button
                      @click="enterExam(list[index], item.beginTime)"
                      type="button"
                      class="btn btn-lg btn-outline-primary enty-exam"
                    >
                      进入考试
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="flag" style="text-align: center;color: darkgray;">
                暂无考试
              </div>

              <!-- <div>

              </div> -->
            </v-spin>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {
      flag: false,
      loadingFlag: false,
      list: [],
      currentTime: "",
      currentDay: "",
      timer: "",
      longTime: 0,
      timer1: "",
      examlist: [],
      weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    };
  },
  created() {
    //添加水印
    this.$watermark({watermark_txt:"职业技能等级认定"});
    
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }

    if (this.timer1) {
      clearInterval(this.timer1); // 在Vue实例销毁前，清除我们的定时器
    }

    this.getSysTime();

    console.log("-=-=-=================" + this.$storage.get("declareUser").id);

    //加载考试列表
    this.loadExamList(this.$storage.get("declareUser").id);
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.timer1) {
      clearInterval(this.timer1); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    //点击进入考试
    async enterExam(data, beginTime) {
      //  if (data != '已开考') {
      //   this.$message({
      //    message: '暂未开考！',
      //     type: 'warning',
      ////      center: true
      //    });
      //    return false;
      //  }

      await this.getSysTime();
      //服务器时间-考试开始时间 大于半小时 则不能进入考场
      /* if (this.longTime - new Date(beginTime).getTime() > 30 * 60 * 1000) {
          this.$message({
            message: '已开考半小时，禁止进入考场！',
            type: 'warning',
            center: true
          });
          return false;
        } */
      this.$router.push({ path: "/examPrepositionPage" });
    },
    //获取服务器时间
    getSysTime() {
      // return new Promise((resolve, reject) => {
      this.$axios
        .post(this.serverUrl + "/serverTime/getServerTime")
        .then(resp => {
          this.longTime = resp.data.serverTime;
          let currentDate = new Date(this.longTime);
          
          //初始化当前时间和星期
          this.currentTime = this.dateFormat("YYYY-mm-dd HH:MM:SS", currentDate);
          this.currentDay = this.getWeekday(currentDate);

          //resolve();
        })
        .catch(err => {});
      // });
    },
    loadExamList(userId) {
      this.loadingFlag = true;
      let parames = new URLSearchParams();
      parames.append("userId", userId);
      let ArrayList = [];
      this.$axios
        .post(this.serverUrl + "/ex/examList", parames)
        .then(resp => {
          //能进来此接口就一定有考试信息 直接循环获取

          resp.data.data.forEach(element => {
            if (
              element.examUserType != null ||
              element.examUserType != undefined
            ) {
              let exam = {
                examTitle: "",
                beginTime: ""
              };
              exam.examTitle = element.examTitle; //标题
              exam.beginTime = element.beginTime; //考试开始时间
              //距离开考 时间
              this.list.push(
                this.showtime(
                  new Date(element.beginTime).getTime(),
                  this.longTime
                )
              );
              ArrayList.push(exam);
            }
          });
          this.examlist = ArrayList;
          console.log(ArrayList);
          if (this.examlist.length == 0) {
            this.flag = true;
          }
          if (this.list.length > 0) {
            let _this = this;
            this.timer1 = setInterval(() => {
              //_this.getSysTime();

              _this.longTime += 1000;
              let currentDate = new Date(_this.longTime);
              
              //时间倒计时
              _this.currentTime = _this.dateFormat(
                "YYYY-mm-dd HH:MM:SS",
                currentDate
              );
              
              //更新星期
              _this.currentDay = _this.getWeekday(currentDate);

              //考试倒计时
              _this.list.forEach(function(element, index) {
                _this.list[index] = _this.showtime(
                  new Date(ArrayList[index].beginTime).getTime(),
                  _this.longTime
                );
              });
            }, 1000);
          }
          this.loadingFlag = false;
        })
        .catch(err => {});
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    getWeekday(date) {
      return this.weekdays[date.getDay()];
    },
    //距离开考时间
    showtime(beginTime, serverTime) {
      var lefttime = beginTime - serverTime; //距离结束时间的毫秒数
      var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)); //计算天数
      var lefth = Math.floor((lefttime / (1000 * 60 * 60)) % 24); //计算小时数
      var leftm = Math.floor((lefttime / (1000 * 60)) % 60); //计算分钟数
      var lefts = Math.floor((lefttime / 1000) % 60); //计算秒数

      if (lefttime <= 1000) {
        return "已开考"; //返回倒计时的字符串
      } else {
        return leftd + "天" + lefth + ":" + leftm + ":" + lefts; //返回倒计时的字符串
      }
    }
  }
};
</script>

<style scoped>
.employer .body .content .info span {
  color: #6f7484;
  margin-right: 15px;
}

.employer .body .content h4 {
  font-size: 20px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-bottom: 12px;
}

a,
a:hover,
a:focus {
  text-decoration: none;
  display: inline-block;
  color: inherit;
  outline: none;
}

.employer .thumb a {
  height: 80px;
  width: 80px;
  position: relative;
}

.employer .thumb a img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

*,
::after,
::before {
  box-sizing: border-box;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-outline-primary {
  color: #007bff;
  background-color: transparent;
  background-image: none;
  border-color: #007bff;
}

.btn-group-lg > .btn,
.btn-lg {
  padding: 0.5rem 1rem;
  font-size: 12.5px;
  line-height: 1.5;
  border-radius: 0.3rem;
}

[type="reset"],
[type="submit"],
button,
html [type="button"] {
  -webkit-appearance: button;
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: calc(100% - 80px);
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.employer .thumb + .body {
  padding-left: 20px;
}

.thumb {
  width: 80px;
  height: 80px;
  background: #f9f9f9;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.selected-options {
  padding: 20px;
  display: none;
  position: relative;
}

.employer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 30px 20px;
  border-radius: 3px;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.showing-number span {
  display: inline-block;
  font-size: 16px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}

.employer-view-controller {
  display: flex;
}

.employer-view-controller-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-bottom: 30px;
}

.employer-filter-wrapper {
  min-width: 240px;
  background-image: linear-gradient(to right, #ffffff, #f7f9fc);
}

.filtered-employer-wrapper {
  font-size: 15px;
  width: calc(100% - 240px);
  padding: 30px 20px;
  background: #ffffff;
  margin: auto;
}

.job-listing-container,
.candidate-container,
.employer-container {
  -webkit-box-shadow: 0px 5px 20px 0px rgb(0 0 0 / 3%);
  box-shadow: 0px 5px 20px 0px rgb(0 0 0 / 3%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.col {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.container {
  max-width: 1200px !important;
}

.section-padding-bottom {
  padding-bottom: 120px;
}

.padding-bottom-70 {
  padding-bottom: 54px;
}

.padding-top-70 {
  padding-top: 0px;
}

.alice-bg {
  background: #f7f9fc;
}

.header-2 {
  -webkit-box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
  z-index: 999;
  background: rgb(0, 50, 93);
}

header {
  position: relative;
}

.container {
  max-width: 1200px !important;
}

.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.header-top {
  padding: 20px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 8px;
}

.header-top .logo-area a img {
  height: 43px;
}

img {
  vertical-align: middle;
  border-style: none;
}

h3 {
  font-size: 36px;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  line-height: 1.3;
  margin-top: 0;
  margin-bottom: 0;
  color: inherit;
}

a,
a:hover,
a:focus {
  text-decoration: none;
  display: inline-block;
  color: inherit;
  outline: none;
}

a {
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/exam/examHomePage.vue